import {
  Component,
  inject,
  OnInit,
  signal,
  ViewChild,
  WritableSignal,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuItemsServiceService } from '../../Services/menu-items.service.service';
import { MenuItem } from '../../models/add-menuItem-request/menuItem.model';
import { CategoryService } from '../../Services/category.service';
import { getAllCategories } from '../../models/Categories Requests DTO/get-categroies.model';
import { CategoriesScrollerComponent } from '../../userComponents/categories-scroller/categories-scroller.component';
import { LanguageService } from '../../Services/language.service';
import { OrderService } from '../../Services/order.service';
import { CouponService } from '../../Services/coupon.service';

@Component({
  selector: 'app-page-menu-items-user',
  templateUrl: './page-menu-items-user.component.html',
  styleUrl: './page-menu-items-user.component.scss',
})
export class PageMenuItemsUserComponent implements OnInit {
  @ViewChild(CategoriesScrollerComponent)
  categoryScroller!: CategoriesScrollerComponent;
  categoryId!: number;
  hasCoupon = false;
  menuItems: MenuItem[] = [];
  category!: getAllCategories;
  couponStatusMap: Map<number, boolean> = new Map();

  MenuTitle: WritableSignal<string> = signal('');
  private languageService = inject(LanguageService);
  private OrderService = inject(OrderService);
  private CouponService = inject(CouponService);
  language = this.languageService.getLanguage();

  constructor(private route: ActivatedRoute) {}

  menuItemsService = inject(MenuItemsServiceService);
  categoryService = inject(CategoryService);
  categoryname!: string;
    onCategorySelected(categoryId: number): void {

    this.recallMenuItems(categoryId);
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    // Access and parse the 'id' as a number
    this.categoryId = +this.route.snapshot.paramMap.get('id')!;
    this.callMenuItems();
    this.languageService.currentLanguage$.subscribe(() => {
      this.updateTitles();
    });
  }


  loaddata() {
    this.languageService.currentLanguage$.subscribe((language) => {
      switch (language) {
        case 'En':
          this.categoryname = this.category.nameEn;
          break;
        case 'Tr':
          this.categoryname = this.category.nameTr;
          break;
        case 'Ar':
          this.categoryname = this.category.nameAr;
          break;
      }
    });
  }

  callMenuItems() {
  
    this.menuItemsService.getAllItemByCategoryId(this.categoryId).subscribe({
      next: (response) => {
        // Get menu items by category
        this.menuItems = response;
        // Sort menu items
        this.menuItems.sort((a, b) => a.itemOrder - b.itemOrder);
  
        // Check coupon existence for each menu item
        this.menuItems.forEach((item) => this.checkItemCouponExist(item.id));
        //console.log(this.couponStatusMap);
  
        // Get category name for header
        this.categoryService.getSingleCategory(this.categoryId).subscribe({
          next: (response) => {
            this.category = response;
          },
          error: (err) => {
           // console.log(err);
          },
        });
      },
      error: (err) => {
       // console.log(err);
      },
    });
  }


  recallMenuItems(id: number) {
    this.menuItemsService.getAllItemByCategoryId(id).subscribe({
      next: (response) => {
        //get menu items by category
        this.menuItems = response;
        //sort menu items
        this.menuItems?.sort((a, b) => a.itemOrder - b.itemOrder);

        //get category name for header
        this.categoryService.getSingleCategory(id).subscribe({
          next: (response) => {
            this.category = response;
          },
          error: (err) => {
           // console.log(err);
          },
        });
      },
      error: (err) => {
      //  console.log(err);
      },
    });
  }

  private updateTitles() {
    // Update titles based on the current language in the service
    this.MenuTitle = this.languageService.MenuPageTitle;
    this.language = this.languageService.getLanguage();
  }

  checkItemCouponExist(menuItemId: number): void {
    this.CouponService.checkMenuItemCoupon(menuItemId).subscribe({
      next: (response) => {
        if (typeof response === 'number' && response >= 0) {
          this.couponStatusMap.set(menuItemId, true);
          //console.log(`Coupon Exists for item ${menuItemId}: ${response}`);
        } else {
          this.couponStatusMap.set(menuItemId, false);
          //console.log(`No Coupon for item ${menuItemId}`);
        }
      },
      error: (err) => {
        //console.error(`Error checking coupon for item ${menuItemId}:`, err);
        this.couponStatusMap.set(menuItemId, false); // Assume no coupon on error
      },
    });
  }
}
